import { ReactNode, useState } from 'react';
import { cn } from '../lib/utils';
import { transCls } from '../const/ui';
import { AnalysisIcon, ChevronIcon } from './bs-icons';

export interface CollapsibleTxtMsgProps {
  title: string;
  content?: string;
  icon?: ReactNode;
  defaultOpen?: boolean;
  children?: ReactNode;

  disableExpand?: boolean;
}

export const CollapsibleTxtMsg = ({
  title,
  content,
  icon,
  disableExpand,
  children,
  defaultOpen,
}: CollapsibleTxtMsgProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-[#fafafa] border border-[#e0e0e0] border-solid flex flex-col gap-2.5 p-2.5 rounded-lg w-full">
      <div
        className={cn('flex items-center justify-between w-full', {
          'cursor-pointer': !disableExpand,
        })}
        onClick={() => {
          if (disableExpand) return;

          setIsOpen(!isOpen);
        }}
      >
        <div className="flex gap-2.5 items-center">
          <div className="w-4 h-4 shrink-0 flex items-center">{icon || <AnalysisIcon />}</div>
          <p className="text-[#666] text-[14px] leading-normal">{title}</p>
        </div>
        <button
          onClick={() => {
            if (disableExpand) return;
            setIsOpen(!isOpen);
          }}
          className={cn(
            'flex items-center justify-center w-5 h-5 rounded-[4px] cursor-pointer hover:bg-[#EFF0F6]',
            transCls,
            {
              'pointer-events-none opacity-0': disableExpand,
            }
          )}
        >
          <ChevronIcon isOpen={isOpen} />
        </button>
      </div>
      {isOpen && !disableExpand && (
        <div className="text-[#121111] text-[14px] word-wrap">{content || children}</div>
      )}
    </div>
  );
};
